import React from 'react';
import MobileDetection from '../../../src/reverb-js-common/mobile_detection';
import LoggedOutRecommendedListingsRow from './logged_out_recommended_listings_row';


export default function LoggedOutRecommendationsRow() {
  if (MobileDetection.isMobileBrowser()) {
    return null;
  } else {
    return <LoggedOutRecommendedListingsRow  />;
  }
}